import script from "./RightSidebarAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./RightSidebarAdmin.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/modules/RightSidebarAdmin.css?vue&type=style&index=0&id=d8348eee&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8348eee"]])

export default __exports__